import { InjectionToken } from '@angular/core';
import { AuthConfig } from '../../models/auth-config/auth-config.model';

export const AUTH_CONFIG = new InjectionToken<Partial<AuthConfig>>(
    'authConfig',
);
